import React from "react";
import { Breadcrumbs } from "web/react/components/breadcrumbs/breadcrumbs";
import { Divider } from "web/react/components/divider";
import { ExpandableText } from "web/react/emo/expandable-text/expandable-text";
import { Heading } from "web/react/emo/heading";
import { useTheEditAnalytics } from "web/react/hooks/use-the-edit-analytics";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./the-edit-header.css";

export function TheEditHeader(): React.ReactElement {
    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "The Edit", url: null },
    ];

    // The Edit
    const title = gettext("the_edit.page_title");

    // Discover The Edit by Lyst, your curated fashion destination.
    // Explore shopping guides, runway reports, designer spotlights, and trend forecasts.
    // Simplify your closet and amplify your style with our expert insights.
    const description = gettext("the_edit.page_description");

    const { containerRef } = useTheEditAnalytics({
        label: "header",
    });

    return (
        <div ref={containerRef} className={styles.container}>
            <Breadcrumbs breadcrumbs={breadcrumbs} type="the_edit" />
            <div className={styles.content}>
                <Heading textStyle={{ sm: "title-1", lg: "hero-xl" }}>{title}</Heading>
                <div className={styles.text}>
                    <ExpandableText lineLimit={2} analyticsCategory={"the_edit"}>
                        {description}
                    </ExpandableText>
                </div>
            </div>
            <Divider />
        </div>
    );
}
